import { createContext, useEffect, useMemo, useState } from "react";
import { getToken, getUser, removeToken, removeUser, setToken, setUser } from "../utils/storage";

export const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [token, setTokenState] = useState(getToken());
    const [user, setUserState] = useState(getUser());

    useEffect(() => {
        if (!token) {
            setUserState(null);
        }
    }, [token]);

    const login = ({ token, user }) => {
        setToken(token);
        setUser(user);
        setTokenState(token);
        setUserState(user);
    };

    const logout = () => {
        removeToken();
        removeUser();
        setTokenState("");
        setUserState(null);
    };

    const value = useMemo(() => ({
        token,
        user,
        isAuthenticated: !!token,
        login,
        logout,
    }), [token, user]);

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}